module.exports = __webpack_public_path__ + "static/media/level1-3.e3d4a3df.mp3";